import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Standard field wrapper using DaisyUI fieldset pattern.
 * See: https://daisyui.com/components/fieldset/
 */
export function FieldWrapper({ label, error, description, required, children, className, showLabel = true, showError = true, showDescription = true }) {
    const hasLabel = showLabel && label;
    const hasError = showError && error;
    const hasDescription = showDescription && description && !hasError;
    return (_jsxs("fieldset", { className: `fieldset ${className ?? ''}`, children: [hasLabel && (_jsxs("legend", { className: "fieldset-legend", children: [label, required && _jsx("span", { className: "text-error text-xs ml-0.5", children: "*" })] })), children, hasError && _jsx("p", { className: "label text-error text-xs", children: error }), hasDescription && _jsx("p", { className: "label text-xs text-base-content/60 line-clamp-2", children: description })] }));
}
